// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fipufDruydu9tXARquBf {
  display: flex;
  height: 100vh;
  background-color: #f9f9f9;
}
  
.R5uxAggADCAouZdEgv2B {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
  margin-top: 20px;
}

.OkhSZAsAVhvZirIIiu0R {
  margin-top: 20px;
}

.XisEWG5zUmcswZOwEGXi {
  font-size: 20px;
  font-weight: bold;
  margin: 20px 0 10px;
}

.aKIJjmthgl8Fanq6_QUR {
  margin-bottom: 20px;
  background-color: #007bff;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}

.aKIJjmthgl8Fanq6_QUR:hover {
  background-color: #0056b3;
}
`, "",{"version":3,"sources":["webpack://./src/pages/SettingsWindow.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".container {\n  display: flex;\n  height: 100vh;\n  background-color: #f9f9f9;\n}\n  \n.title {\n  font-size: 24px;\n  font-weight: bold;\n  margin-bottom: 20px;\n  margin-top: 20px;\n}\n\n.selectedStatus {\n  margin-top: 20px;\n}\n\n.sectionTitle {\n  font-size: 20px;\n  font-weight: bold;\n  margin: 20px 0 10px;\n}\n\n.statusesSyncButton {\n  margin-bottom: 20px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.statusesSyncButton:hover {\n  background-color: #0056b3;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `fipufDruydu9tXARquBf`,
	"title": `R5uxAggADCAouZdEgv2B`,
	"selectedStatus": `OkhSZAsAVhvZirIIiu0R`,
	"sectionTitle": `XisEWG5zUmcswZOwEGXi`,
	"statusesSyncButton": `aKIJjmthgl8Fanq6_QUR`
};
export default ___CSS_LOADER_EXPORT___;
